import { useUserState } from '../../../redux/reducers/userReducer';
import { useAccountState } from '../../../redux/reducers/accountReducer';
import { useState } from 'react';
import { User, UserRef } from '../../../data/types';
import { useCaseService } from '../../../data/services';
import { PersonControl } from '../PersonControl';
import { DropdownMenu } from '../Menus/DropdownMenu';

export type UserDropdownProps = {
    className?: string;
    onUserSelected?: (user?: User | UserRef) => void;
    initialUserId?: string;
    usersToSelectFrom?: (User | UserRef)[];
    includeClearOption?: boolean;
    clearOptionText?: string;
    caseId?: string;
    title?: string;
    size?: 'small' | 'medium' | 'large';
    appearance?: 'underline' | 'outline' | 'filled-darker' | 'filled-lighter';
};
export const UserDropdown = (props: UserDropdownProps) => {
    const { className, onUserSelected, initialUserId, usersToSelectFrom, includeClearOption = false, clearOptionText = 'All', caseId, title, size = 'medium', appearance } = props;

    //Hooks
    const { getUserName } = useAccountState();
    const { users } = useUserState();
    const caseService = useCaseService();

    //State
    const [selectedUserId, setSelectedUserId] = useState<string>(initialUserId || '');

    const clearValue = '';

    //UI Events
    const onUserSelectByMenu = (optionValue: string) => {
        if (!!optionValue) {
            setSelectedUserId(optionValue);

            const selUser = !!optionValue ? getUsers().find((u) => u.userId == optionValue) : undefined;
            onUserSelected && onUserSelected(selUser);
        } else {
            setSelectedUserId(clearValue);
            onUserSelected && onUserSelected(undefined);
        }
    };

    const getUsers = () => {
        return !!usersToSelectFrom?.length
            ? usersToSelectFrom
            : !!caseId
              ? (caseService.cases.find((c) => c.caseId === caseId))?.assignedUsers || []
              : users;
    };

    return (
        <DropdownMenu
            title={title}
            className={className}
            size={size}
            appearance={appearance}
            options={[
                ...(includeClearOption ? [{ label: clearOptionText, value: clearValue }] : []),
                ...getUsers().map((user: User | UserRef) => ({
                    label: getUserName(user.userId) || '',
                    value: user.userId,
                    component: <PersonControl person={user} size='option' />,
                })),
            ]}
            placeholder='Select User'
            onOptionChanged={onUserSelectByMenu}
            initialValue={selectedUserId}
            dataTestId='user-filter-menu'
        />
    );
};
